import React, { useState } from 'react';
import { Helmet } from 'react-helmet';

const Contact: React.FC = () => {
  const [showCopied, setShowCopied] = useState(false);

  const handleCopyEmail = () => {
    if (showCopied) return;
    navigator.clipboard.writeText('asorensentech@gmail.com');
    setShowCopied(true);
    setTimeout(() => setShowCopied(false), 1500);
  };

  return (
  <div className="contact-container">
    <Helmet>
      <title>Contact | Andrew Sorensen</title>
      <meta name="description" content="Get in touch with Andrew Sorensen via LinkedIn or email. Connect to discuss IT projects, automation engineering, or professional opportunities." />
      <meta name="keywords" content="Andrew Sorensen, Contact, LinkedIn, Email, Professional Opportunities, IT Projects, Automation Engineering" />
    </Helmet>
    <div className="contact-title-container">
      <h2 className="page-title">
        Contact Me
      </h2>
    </div>
    <div className="contact-content">
      <div className="contact-content-image-container">
          <img src="/pictures/Contact.jpeg" alt="Andrew Sorensen" className="contact-image" />
      </div>
      <div className="contact-links-container">
        <a 
          href="https://www.linkedin.com/in/andrew-sorensen-qatomic/" 
          target="_blank" 
          rel="noopener noreferrer"
          className="linkedin-link"
        >
          <span className="linkedin-text">Linked</span>
          <svg 
            width="24" 
            height="24" 
            viewBox="0 0 24 24" 
            fill="currentColor"
          >
            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
          </svg>
        </a>
        <br />
        <br />
        <br />
        <br />
        <div className="email-container">
          <a href="mailto:asorensentech@gmail.com" className="email-link">asorensentech@gmail.com</a>
          <div className="copy-button-container">
            <button 
              className="copy-button" 
              onClick={handleCopyEmail}
              title="Copy email address"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="copy-email-icon">
                <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
              </svg>
            </button>
            {showCopied && <div className="copy-popup">Copied</div>}
          </div>
        </div>
      </div>
    </div>
  </div>
  );
};

export default Contact;